// 工具：将快照键转换为时间戳，用于可靠排序（支持不补零的日期）
// 支持格式：
// - YYYY-M-D  或 YYYY-MM-DD（按本地时区，日开始）
// - YYYY-M    或 YYYY-MM    （取当月1号）
// - YYYY-Wn   或 YYYY-Wnn   （ISO周序，粗略换算到该周的周一）

function toInt(s: string | undefined, def = 0): number {
  const n = Number(s);
  return Number.isFinite(n) ? n : def;
}

export function snapshotToTime(key: string): number {
  if (!key) return 0;
  // day: YYYY-M-D 或 YYYY-MM-DD
  let m = key.match(/^\s*(\d{4})-(\d{1,2})-(\d{1,2})\s*$/);
  if (m) {
    const y = toInt(m[1]);
    const mo = toInt(m[2]) - 1; // JS 月份 0-11
    const d = toInt(m[3]);
    return new Date(y, mo, d, 0, 0, 0, 0).getTime();
  }
  // month: YYYY-M 或 YYYY-MM
  m = key.match(/^\s*(\d{4})-(\d{1,2})\s*$/);
  if (m) {
    const y = toInt(m[1]);
    const mo = toInt(m[2]) - 1;
    return new Date(y, mo, 1, 0, 0, 0, 0).getTime();
  }
  // week: YYYY-Wn 或 YYYY-Wnn
  m = key.match(/^\s*(\d{4})-W(\d{1,2})\s*$/i);
  if (m) {
    const y = toInt(m[1]);
    const w = toInt(m[2]);
    // 近似：以当年1月1日为基础 + (w-1)*7 天，再回退到周一
    const jan1 = new Date(y, 0, 1);
    const approx = new Date(jan1.getTime() + (w - 1) * 7 * 86400000);
    const day = approx.getDay() || 7; // 周日=0，换成7
    const monday = new Date(approx.getTime() - (day - 1) * 86400000);
    return monday.getTime();
  }
  // 兜底：字符串倒序，但尽量不让短格式把长格式“压”过去
  // 加权为：年*1e6 + 月*1e4 + 日*1e2
  m = key.match(/^(\d{4})(?:-(\d{1,2}))?(?:-(\d{1,2}))?$/);
  if (m) {
    const y = toInt(m[1]);
    const mo = toInt(m[2]);
    const d = toInt(m[3]);
    return y * 1e6 + mo * 1e4 + d * 1e2;
  }
  return 0;
}

export function compareSnapshotsDesc(a: string, b: string): number {
  return snapshotToTime(b) - snapshotToTime(a);
}
